import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button } from '@mui/material';
import React from 'react';
import { ECCommonErrorBlock } from '../Forms/ECCommonErrorBlock';
import Grid from '@mui/material/Grid';
import TopNotice from '../TopNotice/TopNotice';

const PREFIX = 'CardBlock';

const classes = {
  paper: `${PREFIX}-paper`,
  topDiv: `${PREFIX}-topDiv`,
  middleDiv: `${PREFIX}-middleDiv`,
  bottomDiv: `${PREFIX}-bottomDiv`,
  divider1: `${PREFIX}-divider1`,
  divider2: `${PREFIX}-divider2`,
  space: `${PREFIX}-space`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.paper}`]: {
    boxShadow: theme.shadows[5],
    margin: 'auto',
    marginBottom: theme.spacing(4),
  },

  [`& .${classes.topDiv}`]: {
    padding: theme.spacing(2, 4),
  },

  [`& .${classes.middleDiv}`]: {
    padding: theme.spacing(2, 4),
  },

  [`& .${classes.bottomDiv}`]: {
    textAlign: 'right',
    padding: theme.spacing(2, 4),
  },

  [`& .${classes.divider1}`]: {
    // marginTop: theme.spacing(2),
    // marginBottom: theme.spacing(3),
  },

  [`& .${classes.divider2}`]: {
    // marginTop: theme.spacing(3),
    // marginBottom: theme.spacing(2),
  },

  [`& .${classes.space}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const CardBlock = props => {
  const { title, form, save, hint, children, className, ...rest } = props;

  return (
    <StyledPaper className={`${classes.paper}${className ? ` ${className}` : ''}`}>
      <Grid container spacing={0} className={classes.topDiv}>
        <Grid size={8}>
          <Typography variant='h4'>{title}</Typography>
        </Grid>
        <Grid size={4}>
          <Typography style={{ marginTop: '4px' }}>{hint}</Typography>
        </Grid>
      </Grid>
      <Divider className={classes.divider1} />
      <div className={classes.middleDiv}>
        <ECCommonErrorBlock form={form} />
        {children}
      </div>
      <Divider className={classes.divider2} />
      <div className={classes.bottomDiv}>
        <Button color='primary' variant='contained' className={classes.space} onClick={form.handleSubmit(save)}>
          Сохранить
        </Button>
      </div>
    </StyledPaper>
  );
};

export default CardBlock;
